import React from 'react';
import LoadingIndicator from '../../../components/datatable/LoadingIndicator';
import AjaxDynamicDataTable from '@langleyfoxall/react-dynamic-data-table/dist/AjaxDynamicDataTable';
import EmptyTable from '../../../components/datatable/EmptyTable';
import Button from '../../../components/Button';

export default function InstallationsDataTable() {
  return (
    <div>
      <div className="d-flex justify-content-between align-items-center my-4">
        <h2 className="h4 mb-0 text-eh-navy">
          Installations
        </h2>
      </div>
      <div className="d-flex row">
        <div className="dashboard-data-table mr-4 col">
          <h3 className="h5 text-eh-navy mb-3">
            Today
          </h3>
          <AjaxDynamicDataTable
            apiUrl={route('web-api.dashboard.installations').toString()}
            params={{
              date: 'today',
            }}
            loadingComponent={<LoadingIndicator />}
            noDataComponent={<EmptyTable itemName="installations" />}
            disallowOrderingBy={[
              'customer',
              'job',
              'installers',
              'postcode'
            ]}
            fieldsToExclude={[
              "id",
              "order_id",
              "job_id",
            ]}
            buttons={(row) => (
              <td>
                <a
                  class="text-eh-lilac font-bold"
                  href={(route("job.order.installation.show", {job: row.job_id, order: row.order_id, installation: row.id})).toString()}
                >
                  View
                </a>
              </td>
            )}
            perPageRenderer={() => (
              <div>
                {/* used as a spacer */}
              </div>
            )}
          />
        </div>
        <div className="dashboard-data-table col">
          <h3 className="h5 text-eh-navy mb-3">
            Tomorrow
          </h3>
          <AjaxDynamicDataTable
            apiUrl={route('web-api.dashboard.installations').toString()}
            params={{
              date: 'tomorrow',
            }}
            loadingComponent={<LoadingIndicator />}
            noDataComponent={<EmptyTable itemName="installations" />}
            disallowOrderingBy={[
              'customer',
              'job',
              'installers',
              'postcode'
            ]}
            fieldsToExclude={[
              "id",
              "order_id",
              "job_id",
            ]}
            buttons={(row) => (
              <td>
                <a
                  class="text-eh-lilac font-bold"
                  href={(route("job.order.installation.show", {job: row.job_id, order: row.order_id, installation: row.id})).toString()}
                >
                  View
                </a>
              </td>
            )}
            perPageRenderer={() => (
              <div>
                {/* used as a spacer */}
              </div>
            )}
          />
        </div>
      </div>
    </div>
  );
}
